// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__aOIb3","empty":"ModalGraph_empty__27fpj"};